<!-- eslint-disable max-len -->
<template>
  <b-navbar
    toggleable="lg"
    :variant="getLayoutNavbarBg()"
    class="layout-navbar align-items-lg-center container-p-x"
  >
    <b-navbar-brand
      to="/"
      class="app-brand demo d-lg-none py-0 mr-4"
    >
      <span class="app-brand-logo demo bg-primary">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          version="1.1"
          width="2160"
          height="2160"
          viewBox="0 0 2160 2160"
          xml:space="preserve"
        >
          <desc>Created with Fabric.js 5.2.4</desc>
          <defs />
          <rect
            x="0"
            y="0"
            width="100%"
            height="100%"
            fill="transparent"
          />
          <g
            id="d90e82ed-d7d7-4c21-904e-4eab11f5f121"
            transform="matrix(1 0 0 1 1080 1080)"
          >
            <rect
              style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-rule: nonzero; opacity: 1; visibility: hidden;"
              vector-effect="non-scaling-stroke"
              x="-1080"
              y="-1080"
              rx="0"
              ry="0"
              width="2160"
              height="2160"
            />
          </g>
          <g
            id="ea81d07c-3c5d-450d-839b-4c1378ba95ed"
            transform="matrix(1 0 0 1 1080 1080)"
          />
          <g
            id="d76aa2e2-f570-49ea-8143-5403a99fff74"
            transform="matrix(29.43 0 0 29.43 1080 1080)"
          >
            <path
              style="stroke: rgb(0,0,0); stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,0,0); fill-rule: nonzero; opacity: 1;"
              vector-effect="non-scaling-stroke"
              transform=" translate(-50, -50)"
              d="M 40.747 13.955 L 59.254000000000005 13.955 C 60.353 13.955 61.242000000000004 14.845 61.242000000000004 15.941 L 61.242000000000004 38.787 L 84.08600000000001 38.787 C 85.18400000000001 38.787 86.07000000000001 39.675 86.07000000000001 40.772999999999996 L 86.07000000000001 59.226 C 86.07000000000001 60.324999999999996 85.183 61.211999999999996 84.08600000000001 61.211999999999996 L 61.242 61.211999999999996 L 61.242 84.05799999999999 C 61.242 85.157 60.352 86.044 59.254 86.044 L 40.747 86.044 C 39.652 86.044 38.762 85.15599999999999 38.762 84.05799999999999 L 38.762 61.213 L 15.915 61.213 C 14.819999999999999 61.213 13.93 60.325 13.93 59.227000000000004 L 13.93 40.773 C 13.93 39.67400000000001 14.82 38.787000000000006 15.915 38.787000000000006 L 38.762 38.787000000000006 L 38.762 15.941 C 38.762 14.845 39.651 13.955 40.747 13.955 z"
              stroke-linecap="round"
            />
          </g>
        </svg>
      </span>
      <span class="app-brand-text demo font-weight-normal ml-2">DeVo</span>
    </b-navbar-brand>

    <!-- Sidenav toggle (see demo.css) -->
    <b-navbar-nav
      v-if="sidenavToggle"
      class="layout-sidenav-toggle d-lg-none align-items-lg-center mr-auto"
    >
      <a
        class="nav-item nav-link px-0 mr-lg-4"
        href="javascript:void(0)"
        @click="toggleSidenav"
      >
        <i class="ion ion-md-menu text-large align-middle" />
      </a>
    </b-navbar-nav>

    <b-navbar-toggle target="app-layout-navbar" />

    <b-collapse
      id="app-layout-navbar"
      is-nav
    >
      <b-navbar-nav class="align-items-lg-center ml-auto">
        <b-nav-item-dropdown
          :right="!isRtlMode"
          class="demo-navbar-user"
        >
          <template slot="button-content">
            <i class="ion ion-ios-globe navbar-icon align-middle" />
            <span class="d-lg-none align-middle">&nbsp; {{ $t('menu.navbar.language') }}</span>
          </template>
          <b-dd-item
            @click="setLocale('fr')"
          >
            <i class="ion ion-ios-flag text-lightest" />&nbsp;&nbsp;{{ $t('menu.navbar.french') }}
          </b-dd-item>
          <b-dd-item
            @click="setLocale('de')"
          >
            <i class="ion ion-ios-flag text-lightest" />&nbsp;&nbsp;{{ $t('menu.navbar.german') }}
          </b-dd-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown
          no-caret
          :right="!isRtlMode"
          class="demo-navbar-notifications mr-lg-3"
        >
          <template slot="button-content">
            <i class="ion ion-md-notifications-outline navbar-icon align-middle" />
            <span
              v-if="count > 0"
              class="badge badge-primary badge-pill"
              style="position:absolute;top:0.325rem;font-size:0.75rem;align-items:center;justify-content:center;display:flex;left:1.1rem"
            >{{ count }}</span>
            <span
              v-else
              class="badge badge-primary"
            />
            <span class="d-lg-none align-middle">&nbsp; {{ $t('menu.navbar.notifications') }}</span>
          </template>

          <div class="bg-primary text-center text-white font-weight-bold p-3">
            {{ count }}&nbsp;{{ $t('menu.navbar.notificationMessage') }}
          </div>
          <b-list-group flush>
            <b-list-group-item
              v-for="result in messages"
              :key="result.id"
              class="media d-flex align-items-center"
            >
              <div
                v-if="result.icon != null"
                :class="'ui-icon ui-icon-sm ion ' + result.icon + ' bg-secondary border-0 text-white'"
              />
              <div
                v-else
                class="ui-icon ui-icon-sm ion ion-md-mail bg-secondary border-0 text-white"
              />
              <div
                class="media-body line-height-condenced ml-3"
                @click="showMsgBox(result.title, result.description != null ? result.description : '', result.color != null ? result.color : '', result.icon != null ? result.icon : '')"
              >
                <div
                  v-if="result.color != null"
                  :class="'text-' + result.color"
                >
                  {{ result.title }}
                </div>
                <div
                  v-else
                  class="text-body"
                >
                  {{ result.title }}
                </div>
                <div
                  v-if="result.description != null"
                  class="text-light small mt-1"
                >
                  {{ result.description.substring(0, 100) }}...
                </div>
                <div v-else>
                  &nbsp;
                </div>

                <div class="text-light small mt-1">
                  {{ formatDate(result.from) }}
                </div>
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown
          v-b-toggle.sidebar-right
          no-caret
          :right="!isRtlMode"
          class="demo-navbar-notifications mr-lg-3"
        >
          <template slot="button-content">
            <i class="ion ion-md-speedometer navbar-icon align-middle" />
            <span class="badge badge-primary" />
            <span class="d-lg-none align-middle">&nbsp; {{ $t('menu.navbar.notifications') }}</span>
          </template>
          <dashboard />
        </b-nav-item-dropdown>
        <b-nav-item-dropdown
          :right="!isRtlMode"
          class="demo-navbar-user"
        >
          <template slot="button-content">
            <span class="d-inline-flex flex-lg-row-reverse align-items-center align-middle">
              <img
                :src="`${publicUrl}img/avatars/1.png`"
                alt
                class="d-block ui-w-30 rounded-circle"
              >
              <span class="px-1 mr-lg-2 ml-2 ml-lg-0">{{ this.$store.getters['authorization/data'].firstName }}&nbsp;{{ this.$store.getters['authorization/data'].lastName }}</span>
            </span>
          </template>
          <b-dd-item
            @click="showCurrentUser"
          >
            <i class="ion ion-ios-person text-lightest" /> &nbsp; {{ $t('menu.navbar.profile') }}
          </b-dd-item>
          <b-dd-divider />
          <b-dd-item @click="logOut">
            <i class="ion ion-ios-log-out text-danger" /> &nbsp; {{ $t('menu.navbar.logout') }}
          </b-dd-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import moment from 'moment';
import messages from '../services/Messages';
import authorizationMixin from '../store/mixins/store-authorization';

import Dashboard from '../components/Dashboard.vue';

export default {
  name: 'AppLayoutNavbar',
  components: {
    dashboard: Dashboard,
  },
  mixins: [
    authorizationMixin,
  ],
  props: {
    sidenavToggle: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      messages: null,
      count: 0,
    };
  },
  mounted() {
    this.getMessages();
    this.$root.$on('forceUpdateMessages', () => {
      this.getMessages();
    });
  },
  methods: {
    logOut() {
      this.$msal.logout();
    },
    setLocale(lang) {
      this.$store.dispatch('settings/setLanguage', lang);
      this.$i18n.locale = lang;
      window.location.reload();
    },
    showCurrentUser() {
      this.$root.$emit('updateUserModal', this.$store.getters['authorization/data']);
    },
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    showMsgBox(title, text, color, icon) {
      try {
        let titleHtml = '';
        if (String(icon) !== '') {
          titleHtml = `<div class="ui-icon ui-icon-sm ion ${icon} bg-secondary border-0 text-white"></div><span class="ml-2 text-uppercase">${title}</span>`;
        } else {
          titleHtml = `<div class="ui-icon ui-icon-sm ion ion-md-mail bg-secondary border-0 text-white"></div><span class="ml-2 text-uppercase">${title}</span>`;
        }
        this.$bvModal.msgBoxOk(text, {
          titleHtml,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: color,
          okTitle: this.$t('control.button.ok'),
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          headerTextVariant: color,
          centered: true,
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(`ERROR LayoutNavBar: ${error}`); // TODO notification system
      }
    },
    async getMessages() {
      messages.baseUrl = this.$store.state.settings.apiBaseUrl;
      const result = await messages.getActiveMessages();
      this.$nextTick(() => {
        if (result[1] != null) {
          // eslint-disable-next-line prefer-destructuring
          this.messages = result[1];
          this.count = this.messages.length;
        } else {
          this.count = 0;
        }
      });
    },
    toggleSidenav() {
      this.layoutHelpers.toggleCollapsed();
    },

    getLayoutNavbarBg() {
      return this.layoutNavbarBg;
    },
  },
};
</script>
